var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({ref:"loginRef",tag:"component"},'component',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }